import {
  Card,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  formatPhoneNumber,
} from "@compass/core";
import { TextingQueueDetailDto, TextingQueueItemDetailDto } from "generated/openApi";
import { TextingStatusChip } from "../TextingStatusChip";

const getDeliveryStatus = (item: TextingQueueItemDetailDto) => {
  if (item.sent === true)
    return <TextingStatusChip status="Sent" />;

  if (item.sent === false)
    return <Chip label="Not Sent" color="warning" size="small" variant="outlined" />;

  return <Chip label="Pending" size="small" variant="outlined" />;
};

export const TextingQueueItems = (props: { textingQueue: TextingQueueDetailDto }) => (
  <Card header={`Recipients (${props.textingQueue.items?.length || 0})`}>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Recipient</TableCell>
            <TableCell>Phone Number</TableCell>
            <TableCell>Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.textingQueue.items?.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{getDeliveryStatus(item)}</TableCell>
              <TableCell>
                <Stack>
                  <Typography variant="inherit">
                    {item.personName || "Recipient unavailable"}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell>{formatPhoneNumber(item.destinationPhoneNumber) || "-"}</TableCell>
              <TableCell sx={{ maxWidth: 520, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                {item.outputMessage || props.textingQueue.message || "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Card>
);
